import { setHeaderTabsValue } from '@/slices/headerTabs/slices/headerTabsSlice';
import { style } from '@/styles/globals';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { Tab } from '@mui/material';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { uniqueId } from 'lodash';
import React from 'react';
import type { TabPanelProps, TabsProps } from './index.d';

function TabPanel(props: TabPanelProps) {
  const {
    children, value, index, ...other
  } = props;

  return index === value ? (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  ) : null;
}

const typeArr = ['flight', 'bus', 'train'];
const typeMapping: { [key: string]: string } = {
  flight: 'Máy bay',
  bus: 'Xe khách',
  train: 'Tàu hỏa',
};

const CustomTabs = ({
  labelObjs, variant, tabComponent, onClickTab, changeRoutePage,
}: TabsProps, ref: any) => {
  const value = useAppSelector((state) => state.headerTabs);
  const dispatch = useAppDispatch();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (changeRoutePage && typeArr[newValue]) {
      changeRoutePage(typeArr[newValue]);
    }
    dispatch(setHeaderTabsValue(newValue));
  };

  React.useImperativeHandle(ref, () => ({
    setTab: (index: number) => {
      dispatch(setHeaderTabsValue(index));
    },
  }));

  return (
    <Box sx={{
      width: '100%',
    }}
    >
      <Box
        style={{
          borderRadius: pr`16px`,
          // boxShadow: style.boxShadow.customShadow,
          marginLeft: pr`16px`,
          marginRight: pr`16px`,
          background: style.color.white4,
          border: `solid 2px ${style.color.white1}`,
        }}
      >
        <Tabs
          value={value || 0}
          variant={variant as any || 'standard'}
          sx={{
            display: 'flex',
            '& .MuiTabs-flexContainer': {
              maxHeight: '76px',
            },
          }}
          onChange={handleChange}
          aria-label="transportation tabs"
          TabIndicatorProps={{
            style: {
              // background: showTabIndicator ? style.color.product3 : 'transparent',
              background: 'transparent',
            },
          }}
        >
          {labelObjs.map((labelObj) => {
            const disabled = labelObj.type !== Object.keys(typeMapping)[value];
            const color = !disabled ? style.color.product3 : style.color.black3;
            return (
              <Tab
                sx={{ flex: 1 }}
                icon={labelObj.icon}
                label={!labelObj.routeInfo ? (typeMapping[labelObj.type] || '') : labelObj.routeInfo(color)}
                aria-label={labelObj.ariaName}
                key={uniqueId()}
                onClick={() => onClickTab && onClickTab(labelObj.type)}
                // disabled={labelObj.type !== typeMapping[value]}
                style={{
                  borderRadius: pr`12px`,
                  margin: pr`7px`,
                  textTransform: 'inherit',
                  background: (!disabled ? style.color.product4 : ''),
                  color: (!disabled ? style.color.product3 : 'style.color.black4'),
                  padding: pr`8px`,
                  fontSize: pr`12px`,
                  minHeight: 0,
                }}
              />
            );
          })}
        </Tabs>
      </Box>
      {tabComponent ? (
        <div style={{
          padding: pr`16px`,
          paddingBottom: 0,
        }}
        >
          {labelObjs.map((labelObj, index) => (
            <TabPanel
              value={value}
              key={uniqueId()}
              index={index}
            >
              <div>{tabComponent[index]}</div>
            </TabPanel>
          ))}
        </div>
      ) : null}
    </Box>
  );
};

export default React.forwardRef(CustomTabs);
